var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7237 16.8516C14.4782 16.8516 15.9005 15.4293 15.9005 13.6748C15.9005 11.9203 14.4782 10.498 12.7237 10.498C10.9692 10.498 9.54688 11.9203 9.54688 13.6748C9.54688 15.4293 10.9692 16.8516 12.7237 16.8516Z",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95703 19.2342C8.51186 18.4944 9.23131 17.8939 10.0584 17.4804C10.8855 17.0669 11.7975 16.8516 12.7222 16.8516C13.6469 16.8516 14.5589 17.0669 15.386 17.4804C16.2131 17.8939 16.9326 18.4944 17.4874 19.2342",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 21.6171V4.14478C20.6641 3.70616 20.3085 3.35059 19.8699 3.35059L5.57432 3.35059C5.13569 3.35059 4.78012 3.70616 4.78012 4.14478L4.78012 21.6171C4.78012 22.0557 5.13569 22.4113 5.57432 22.4113H19.8699C20.3085 22.4113 20.6641 22.0557 20.6641 21.6171Z",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54688 6.52734H15.9005",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentify);
export default __webpack_public_path__ + "static/media/identify.ec91a5c127462606f1f4a873135fc98d.svg";
export { ForwardRef as ReactComponent };